export const common = {
  "home.awards.title": "Premios y reconocimientos",
  "home.awards.pause": "Pausar el carrusel de premios",
  "home.awards.play": "Reanudar el carrusel de premios",
  "home.awards.financialAlgorithm": "Empresa líder en algoritmos financieros",
  "home.awards.asiaPacificGold": "Marca líder en negociación de oro en Asia-Pacífico",
  "home.awards.preciousMetals": "Marca de confianza en negociación de metales preciosos",
  "home.awards.digitalFinance": "Contribución a la innovación en finanzas digitales",
  "home.awards.quantitativeTrading": "Empresa destacada en tecnología de negociación cuantitativa",
    // Navigation
  'nav.home': 'Inicio',
  'nav.trading': 'Trading',
  'nav.markets': 'Mercados',
  'nav.news': 'Noticias',
  'nav.about': 'Acerca de',
  'nav.contact': 'Contacto',
  'nav.login': 'Iniciar sesión',
  'nav.register': 'Registrarse',

  // Hero Section
  'hero.title': 'Plataforma premium de trading de oro y plata',
  'hero.subtitle': 'Empresa con licencia en Hong Kong que ofrece trading de metales preciosos seguro y profesional para inversores europeos',
  'hero.cta.start': 'Comenzar a operar',
  'hero.cta.learn': 'Más información',

  // Home
  'home.licenseHK': 'Con licencia en Hong Kong',
  'home.bankSec': 'Seguridad de nivel bancario',
  'home.247s': 'Soporte 24/7',
  'home.global': 'Enfoque global',
  'home.tradingPlat': 'Plataforma de trading',
  'home.tradingWith': 'Opera con ',
  'home.exp': 'Experimente la plataforma de trading más avanzada del mundo, diseñada para el comercio de metales preciosos. MT5 ofrece herramientas de nivel institucional, ejecución ultrarrápida y análisis de mercado integral.',
  'home.dlMT5': 'Descargar MT5',
  'home.watchDemo': 'Ver demostración',
  'home.tradingIns': 'Instrumentos de trading',
  'home.exeSpeed': 'Velocidad de ejecución',
  'home.mktAccess': 'Acceso al mercado',
  'home.uptime': 'Disponibilidad',
  'home.allDevices': 'Disponible en todos los dispositivos',
  'home.mktInt': 'Inteligencia de mercado',
  'home.mktInt.desc': 'Manténgase informado con eventos económicos en tiempo real y noticias de mercado que impactan el trading de metales preciosos',
  'home.lastUpdate': 'Última actualización',
  'home.ecoCal': 'Calendario económico',
  'home.refresh': 'Actualizar',
  'home.currency': 'Divisa',
  'home.events': 'Eventos',
  'home.previous': 'Anterior',
  'home.forecast': 'Previsión',
  'home.actual': 'Actual',
  'home.mktNews': 'Noticias del mercado',
  'home.seeMore': 'Ver más',
  'home.ecoData': 'Datos económicos proporcionados por múltiples proveedores financieros • Noticias de mercado de publicaciones financieras líderes',
  'home.ac': 'Gráficos avanzados',
  'home.pta': 'Análisis técnico profesional con más de 80 indicadores y herramientas analíticas',
  'home.mpa': 'Acceso multiplataforma',
  'home.tsa': 'Opera sin interrupciones en aplicaciones de escritorio, web y móvil',
  'home.st': 'Trading seguro',
  'home.bls': 'Seguridad de nivel bancario con transmisión y almacenamiento de datos cifrados',
  'home.247': 'Acceso al mercado 24/7',
  'home.rtc': 'Acceso continuo de negociación a los mercados globales de metales preciosos',
  'home.at': 'Trading automatizado',
  'home.ea': 'Expert Advisors (EAs) para estrategias algorítmicas y automatizadas',
  'home.lfe': 'Ejecución ultrarrápida',
  'home.ull': 'Ejecución de órdenes con latencia ultrabaja y spreads competitivos',

  // Features
  'features.title': 'Por qué elegir nuestra plataforma',
  'features.security.title': 'Seguridad de nivel bancario',
  'features.security.desc': 'El cifrado avanzado y los protocolos de seguridad multicapa protegen sus inversiones',
  'features.licensed.title': 'Totalmente autorizada',
  'features.licensed.desc': 'Empresa regulada en Hong Kong con pleno cumplimiento y transparencia',
  'features.realtime.title': 'Trading en tiempo real',
  'features.realtime.desc': 'Datos de mercado en vivo y ejecución instantánea para oportunidades óptimas',
  'features.support.title': 'Soporte 24/7',
  'features.support.desc': 'Equipo profesional multilingüe disponible en todo momento',
  'features.lmd': 'Datos de mercado en vivo',
  'features.rtp': 'Precios de metales preciosos en tiempo real',

  // Markets
  'markets.title': 'Precios de mercado en vivo',
  'markets.gold': 'Oro',
  'markets.silver': 'Plata',
  'markets.platinum': 'Platino',
  'markets.palladium': 'Paladio',
  'markets.price': 'Precio',
  'markets.change': 'Variación',
  'markets.high': 'Máximo 24h',
  'markets.low': 'Mínimo 24h',
  'markets.contractDetials': 'Detalles del contrato',
  'markets.contractDetials.desc': 'Especificaciones completas del contrato y condiciones de negociación para metales preciosos',
  'markets.tradingExample': 'Ejemplo de trading',
  'markets.goldExample': 'Ejemplo de trading de oro',
  'markets.silverExample': 'Ejemplo de trading de plata',
  'markets.instrument': 'Instrumento',
  'markets.lotSize': 'Tamaño de lote',
  'markets.entPrice': 'Precio de entrada',
  'markets.marReq': 'Margen requerido',
  'markets.pip': 'Valor del pip',
  'markets.pmt': 'Negociación de metales preciosos',
  'markets.ctt': 'Términos, condiciones y especificaciones integrales para el trading de metales preciosos. Comprenda los detalles del contrato, los requisitos de margen y la gestión de riesgos para inversiones en oro y plata.',
  'markets.vts': 'Ver especificaciones de trading',
  'markets.dcd': 'Descargar detalles del contrato',
  'markets.ec': 'Velocidad de ejecución',
  'markets.th': 'Horario de trading',
  'markets.ms': 'Spread mínimo (pips)',
  'markets.ml': 'Apalancamiento máximo',
  'markets.mr': 'Requisitos de margen',
  'markets.lo': 'Opciones de apalancamiento y requisitos de margen según el tipo de cuenta',
  'markets.leverage': 'Apalancamiento',
  'markets.margin': 'Margen',
  'markets.mind': 'Depósito mínimo',
  'markets.mc': 'Calculadora de margen',
  'markets.gmc': 'Cálculo de margen del oro',
  'markets.cp': 'Precio actual',
  'markets.cv': 'Valor del contrato',
  'markets.smc': 'Cálculo de margen de la plata',
  'markets.rm': 'Gestión de riesgos',
  'markets.crm': 'Herramientas y estrategias integrales de gestión de riesgos para proteger sus inversiones',
  'markets.rtg': 'Guía de tolerancia al riesgo',
  'markets.rd': 'Divulgación de riesgos',
  'markets.tpm': 'El trading de metales preciosos implica un riesgo sustancial de pérdida y puede no ser adecuado para todos los inversores. El rendimiento pasado no es indicativo de resultados futuros.',
  'markets.lcw': 'El apalancamiento puede actuar en su contra tanto como a su favor. Antes de decidir operar, considere cuidadosamente sus objetivos de inversión, nivel de experiencia y apetito de riesgo.',
  'markets.ysb': 'Debe conocer todos los riesgos asociados al trading de metales preciosos y buscar asesoramiento de un asesor financiero independiente si tiene dudas.',
  'markets.rfr': 'Leer la divulgación completa de riesgos',
  'markets.cra': 'Contactar asesor de riesgos',
  'markets.tho': 'Horario de trading',
  'markets.moh': 'Horario de funcionamiento del mercado y calendario de festivos para el trading de metales preciosos',
  'markets.wts': 'Calendario semanal de trading',
  'markets.note': 'Nota',
  'markets.atad': 'Todas las horas se muestran en GMT+8. El trading puede suspenderse durante días festivos importantes y periodos de alta volatilidad.',
  'markets.hs': 'Calendario de festivos',
  'markets.mclo': 'Mercado cerrado',
  'markets.eclo': 'Cierre anticipado',
  'markets.hn': 'Aviso de festivos',
  'markets.thm': 'El horario de trading puede ajustarse durante festivos nacionales. Consulte nuestros anuncios para cambios de calendario.',
  'markets.cms': 'Estado actual del mercado',
  'markets.mac': 'Los mercados están actualmente ABIERTOS para operar',
  'markets.st': 'Hora del servidor (GMT+8)',
  'markets.ts': 'Especificaciones de trading',
  'markets.dtc': 'Condiciones y especificaciones detalladas para instrumentos de oro y plata',
  'markets.msp': 'Spread mínimo',
  'markets.minls': 'Tamaño mínimo de lote',
  'markets.maxls': 'Tamaño máximo de lote',
  'markets.commission': 'Comisión',
  'markets.sls': 'Swap largo/corto',
  'markets.in': 'Notas importantes',
  'markets.smv': 'Los spreads pueden variar durante periodos de alta volatilidad y anuncios de noticias importantes',
  'markets.sra': 'Las tasas de swap se actualizan diariamente y pueden cambiar según las condiciones del mercado',
  'markets.mlm': 'El apalancamiento máximo puede reducirse durante eventos económicos de alto impacto',
  'markets.ata': 'Todas las horas se muestran en la zona horaria GMT+8',

  // News
  'news.title': 'Últimas noticias y análisis de mercado',
  'news.subtitle': 'Manténgase informado con perspectivas de expertos y actualizaciones del mercado',
  'news.readMore': 'Leer más',
  'news.category.analysis': 'Análisis de mercado',
  'news.category.news': 'Última hora',
  'news.category.insights': 'Perspectivas de expertos',
  'news.category.education': 'Formación',
  'news.date': 'Publicado',
  'news.author': 'Por',

  // Testimonials
  'home.partners.title': 'Nuestros socios',
  'home.partners.subtitle': 'Colaboramos con proveedores líderes mundiales de liquidez, tecnología financiera e infraestructura de trading.',
  'testimonials.title': 'Con la confianza de inversores en todo el mundo',
  'testimonials.client1.name': 'Marcus Weber',
  'testimonials.client1.location': 'Fráncfort, Alemania',
  'testimonials.client1.text': 'Plataforma excelente con precios transparentes y ejecución fiable. Las funciones de seguridad me dan total confianza.',
  'testimonials.client2.name': 'Sophie Dubois',
  'testimonials.client2.location': 'París, Francia',
  'testimonials.client2.text': 'Servicio profesional y spreads competitivos. El equipo de soporte multilingüe es increíblemente útil.',
  'testimonials.client3.name': 'Alessandro Rossi',
  'testimonials.client3.location': 'Milán, Italia',
  'testimonials.client3.text': 'Ejecución rápida y excelentes herramientas de análisis de mercado. Muy recomendable para trading serio de metales preciosos.',

  // Footer
  'footer.company': 'Empresa',
  'footer.trading': 'Trading',
  'footer.support': 'Soporte',
  'footer.legal': 'Legal',
  'footer.about': 'Sobre nosotros',
  'footer.careers': 'Empleo',
  'footer.news': 'Noticias',
  'footer.platforms': 'Plataformas de trading',
  'footer.education': 'Formación',
  'footer.analysis': 'Análisis de mercado',
  'footer.help': 'Centro de ayuda',
  'footer.contact': 'Contáctenos',
  'footer.faq': 'Preguntas frecuentes',
  'footer.terms': 'Términos de servicio',
  'footer.privacy': 'Política de privacidad',
  'footer.risk': 'Divulgación de riesgos',
  'footer.copyright': '© 2024 GOLD Label Global Limited. Todos los derechos reservados.',
  'footer.license': "Sociedad constituida en Hong Kong",
  'footer.riskwarning': 'Advertencia de riesgos',
  'footer.disclaimer': 'El trading con margen es un producto financiero apalancado que puede ocasionar pérdidas superiores a sus depósitos. Usted no posee ni mantiene realmente activos subyacentes. Lea atentamente nuestra Declaración de divulgación de riesgos antes de operar. Asegúrese de comprender plenamente los riesgos implicados y gestione prudentemente su exposición. No aceptamos responsabilidad por acciones u omisiones realizadas por individuos basándose en la información de este sitio web o su contenido.',
  'footer.jurisdiction': "Aviso jurisdiccional",
  'footer.jurisdictionDisclaimer': "Los servicios se ofrecen únicamente a clientes elegibles en jurisdicciones fuera de Hong Kong y Estados Unidos, siempre que su prestación sea lícita conforme a las leyes aplicables de la jurisdicción del cliente. No se ofrecen servicios a residentes de Hong Kong o Estados Unidos, ni a personas en jurisdicciones donde dichos servicios sean ilegales o estén prohibidos. Este sitio web no está dirigido a personas en jurisdicciones restringidas ni constituye una oferta, solicitud o recomendación para ellas.",
  'footer.relatedEntity': 'Otra entidad relacionada',
  'footer.saintLuciaEntity': 'Gold Label Global (SL) Limited es una International Business Company constituida en Santa Lucía el 4 de septiembre de 2026, con número de registro 2026-00680. Domicilio social: Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia. El domicilio social se mantiene exclusivamente para el cumplimiento de obligaciones legales y reglamentarias. No constituye la sede operativa de la empresa ni se utiliza para operaciones, visitas de clientes o correspondencia.',
  'footer.regNo': 'Número de registro de la empresa',

  // Common
  'common.language': 'Idioma',
  'common.loading': 'Cargando...',
  'common.error': 'Error',
  'common.success': 'Éxito',
  'common.close': 'Cerrar',
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.continue': 'Continuar',
  'common.back': 'Atrás',
  'common.next': 'Siguiente',
  'common.previous': 'Anterior',
  'common.submit': 'Enviar',
  'common.reset': 'Restablecer',

  // About
  'about.yearsOfExp': 'Años de experiencia',
  'about.yearsOfExp.desc': 'Décadas de experiencia en el trading de metales preciosos',
  'about.dailyTrade': 'Volumen diario de negociación',
  'about.dailyTrade.desc': '80.000 millones HKD en transacciones diarias de oro y plata',
  'about.satClients': 'Clientes satisfechos',
  'about.satClients.desc': 'Atendiendo a innumerables clientes e instituciones en todo el mundo',
  'about.exeSpeed': 'Velocidad de ejecución',
  'about.exeSpeed.desc': 'Tecnología de ejecución de órdenes ultrarrápida',
  'about.ourAch': 'Nuestros logros',
  'about.ourAch.desc': 'Excelencia reconocida en el trading de metales preciosos con rendimiento líder del sector',
  'about.companyProfile': 'Perfil de la empresa',
  'about.about1': 'Acerca de Gold Label Global',
  'about.about2': 'Gold Label Global Limited es una sociedad limitada registrada y aprobada por el gobierno de Hong Kong, y miembro de la Chinese Gold and Silver Exchange Society. Hong Kong procesa diariamente transacciones de oro y plata por valor de 80.000 millones de HKD, con una experiencia líder mundial.',
  'about.about3': 'El equipo directivo de Gold Label Global cuenta con más de veinte años de experiencia especializada en el trading de oro y plata. Hemos servido a innumerables clientes e instituciones, gestionando operaciones por decenas de miles de millones, y hemos recibido un gran reconocimiento de clientes y profesionales del sector.',
  'about.about4': 'Estamos comprometidos a proporcionar a los clientes un entorno de negociación rápido, estable y excelente. A nivel técnico, adoptamos sistemas de trading de nivel internacional y seleccionamos equipos tecnológicos de primer nivel para desarrollar soluciones más potentes e integrales, mejorando la velocidad de trading para que sea más rápida, más estable y más completa.',
  'about.about5': 'Gold Label Global seguirá creando valor con usted y compartiendo la prosperidad.',
  'about.about6': 'Descubra nuestro recorrido en el trading de metales preciosos y nuestro compromiso con la excelencia en los mercados financieros globales.',
  'about.about7': 'Como sociedad limitada registrada y aprobada por el gobierno de Hong Kong y miembro de la Chinese Gold & Silver Exchange Society, gestionamos 80.000 millones de HKD en transacciones diarias de oro y plata, liderando el mundo en experiencia de trading.',
  'about.proTeam': 'Equipo profesional',
  'about.proTeam.desc': 'Nuestro equipo directivo cuenta con más de 20 años de experiencia centrada en el trading de oro y plata, habiendo atendido a innumerables clientes e instituciones.',
  'about.proService': 'Servicio profesional',
  'about.proService.desc': 'Equipo de atención profesional que ofrece servicio al cliente en línea 24 horas y asesoría móvil, además de soluciones específicas a los problemas de los clientes.',
  'about.sec': 'Seguridad ante todo',
  'about.sec.desc': 'Sin contraparte de negociación: las operaciones entran directamente al mercado; transparencia y seguridad.',
  'about.strict': 'Supervisión estricta',
  'about.strict.desc': 'Gold Label Global es un mercado comercial en Hong Kong, regulado por el gobierno de Hong Kong y miembro de la Asociación de Comercio Comercial de Hong Kong.',
  'about.fastDes': 'Depósito rápido',
  'about.fastDes.desc': 'Servicio 24 horas, depósito en segundos y apertura de cuenta instantánea.',
  'about.productSafe': 'Seguridad del producto',
  'about.productSafe.desc': 'Cobertura de todos los principales productos mundiales de metales preciosos, con seguridad garantizada.',
  'about.whyGLB': 'Por qué elegir Gold Label Global',
  'about.whyGLB.desc': 'Descubra las ventajas que nos convierten en la opción líder para el trading de metales preciosos',
  'about.readyToStart': '¿Listo para empezar a operar?',
  'about.join': 'Únase a miles de clientes satisfechos que confían en GOLD Label Global para sus necesidades de trading de metales preciosos.',
  'about.openTradingAcc': 'Abrir cuenta de trading',
  'about.contactTeam': 'Contactar con nuestro equipo',
  'about.co': 'Cooperación',
  'about.co.desc': 'Construimos asociaciones mutuamente beneficiosas con nuestros clientes y grupos de interés',
  'about.safety': 'Seguridad',
  'about.safety.desc': 'Garantizar el máximo nivel de seguridad para todas las actividades de trading',
  'about.integrity': 'Integridad',
  'about.integrity.desc': 'Mantener los más altos estándares de honestidad y transparencia',
  'about.professional': 'Profesional',
  'about.professional.desc': 'Ofrecer servicios expertos con un profesionalismo inigualable',
  'about.fast': 'Rapidez',
  'about.fast.desc': 'Proporcionar ejecución rápida y un servicio de atención ágil',
  'about.coreValue': 'Nuestros valores fundamentales',
  'about.coreValue.desc': 'Los principios que guían nuestro compromiso con la excelencia en el trading de metales preciosos',

  // Contact
  'contact.sendUsMsg': 'Envíenos un mensaje',
  'contact.fillOut': 'Complete el siguiente formulario y nuestro equipo le responderá dentro de 24 horas.',
  'contact.inqType': 'Tipo de consulta',
  'contact.genInq': 'Consulta general',
  'contact.accSup': 'Soporte de cuenta',
  'contact.traSup': 'Soporte de trading',
  'contact.techSup': 'Soporte técnico',
  'contact.partner': 'Colaboración',
  'contact.fullname': 'Nombre completo *',
  'contact.email': 'Dirección de correo *',
  'contact.phone': 'Número de teléfono',
  'contact.subject': 'Asunto *',
  'contact.msg': 'Mensaje *',
  'contact.sendMsg': 'Enviar mensaje',
  'contact.whyUs': '¿Por qué elegirnos?',
  'contact.regSec': 'Regulado y seguro',
  'contact.licAndReg': 'Entorno de negociación autorizado y regulado, con medidas de seguridad avanzadas para proteger sus inversiones.',
  'contact.expSup': 'Asistencia experta',
  'contact.proService': 'Especialistas en trading disponibles 24/7 para ayudarle con sus necesidades y preguntas.',
  'contact.fastExe': 'Ejecución rápida',
  'contact.lightFast': 'Ejecución de órdenes ultrarrápida con deslizamiento mínimo para un rendimiento óptimo.',
  'contact.glbNet': 'Mercados globales',
  'contact.asscessToint': 'Acceso a los mercados internacionales de metales preciosos con spreads competitivos y alta liquidez.',
  'contact.followUs': 'Síganos en redes sociales:',
  'contact.contactOutPro': 'Póngase en contacto con nuestro equipo profesional para soporte de trading, ayuda con la cuenta o consultas generales:',
  'contact.officeAddress': 'Dirección de la oficina',
  'contact.bussHour': 'Horario comercial: Lun–Vie 9:00–18:00 (GMT+8)',
  'contact.phoneSupp': 'Soporte telefónico',
  'contact.mainOffice': 'Oficina principal',
  'contact.availableServices': 'Servicios disponibles:',
  'contact.accOpenSup': 'Asistencia para apertura de cuenta',
  'contact.tradSup': 'Asistencia de la plataforma de trading',
  'contact.genSup': 'Soporte general',
  'contact.emailSup': 'Soporte por correo electrónico',
  'contact.responseTime': 'Tiempo de respuesta:',
  'contact.genInq24': 'Consultas generales: dentro de 24 horas',
  'contact.techSup24': 'Soporte técnico: dentro de 4 horas',
  'contact.accIss24': 'Problemas de cuenta: dentro de 2 horas',
  'contact.needImSup': '¿Necesita asistencia inmediata?',
  'contact.needImSup.desc': 'Nuestros especialistas en trading están disponibles 24/7 para ayudarle con asuntos urgentes y soporte de cuenta.',
  'contact.callNow': 'Llamar ahora',
  'contact.sendEmail': 'Enviar correo',
  'contact.contactUs': 'Contáctenos',
  'contact.getInTouch': 'Póngase en contacto con nuestro equipo profesional de trading. Estamos aquí para ayudarle a tener éxito en el trading de metales preciosos.',
  'contact.247Sup': 'Soporte 24/7',
  'contact.247Sup.desc': 'Atención al cliente ininterrumpida para todas sus necesidades de trading',
  'contact.dirLine': 'Línea directa',
  'contact.dirLine.desc': 'Hable directamente con nuestros especialistas en trading',
  'contact.hkOffice': 'Oficina de Hong Kong',
  'contact.hkOffice.desc': 'Ubicada en el corazón del distrito financiero de Hong Kong',

  // Platform
  'platform.wco': '¿Por qué elegir nuestra plataforma MT5?',
  'platform.etd': 'Experimente la diferencia con nuestra plataforma premium diseñada para traders serios',
  'platform.rts': '¿Listo para empezar a operar?',
  'platform.jto': 'Únase a miles de traders que confían en nuestra plataforma para su trading de metales preciosos',
  'platform.ola': 'Abrir cuenta real',
  'platform.tda': 'Probar cuenta demo',
  'platform.dmt': 'Descargar plataforma MT5',
  'platform.ayt': 'Acceda a su cuenta de trading desde cualquier dispositivo con nuestras aplicaciones MT5 multiplataforma',
  'platform.free': 'Gratis',
  'platform.dn': 'Descargar ahora',
  'platform.sr': 'Requisitos del sistema',
  'platform.nh': '¿Necesita ayuda para empezar?',
  'platform.os': 'Nuestro equipo de soporte está listo para ayudarle a configurar y comenzar a operar',
  'platform.ug': 'Guía del usuario',
  'platform.cs': 'Contactar soporte',
  'platform.si': 'Se requiere conexión a Internet estable',
  'platform.ptf': 'Potentes funciones de trading',
  'platform.epg': 'Experimente herramientas de nivel profesional diseñadas tanto para principiantes como para expertos',
  'platform.ac': 'Gráficos avanzados',
  'platform.pct': 'Herramientas de gráficos profesionales con más de 80 indicadores técnicos y múltiples marcos temporales para un análisis integral del mercado.',
  'platform.lfe': 'Ejecución ultrarrápida',
  'platform.ull': 'Trading con latencia ultrabaja y velocidades de ejecución de hasta 0,01 segundos para entradas y salidas óptimas.',
  'platform.ea': 'Expert Advisors (EAs)',
  'platform.atc': 'Capacidades de trading automatizado con EAs personalizados y estrategias algorítmicas.',
  'platform.rm': 'Gestión de riesgos',
  'platform.crm': 'Conjunto completo de herramientas de gestión de riesgos, incluyendo stop loss, take profit y control del tamaño de posición.',
  'platform.mpa': 'Acceso multiplataforma',
  'platform.tsa': 'Opere sin interrupciones en escritorio, web y móvil con acceso sincronizado a su cuenta.',
  'platform.gm': 'Mercados globales',
  'platform.ati': 'Acceso a mercados internacionales, incluidos metales preciosos, divisas, índices y materias primas.',
  'platform.etw': 'Experimente la plataforma de trading más avanzada del mundo. Opere metales preciosos, divisas y CFD con tecnología de nivel institucional y ejecución ultrarrápida.',
  'platform.download': 'Descargar ',
  'platform.wd': 'Ver demostración',
  'platform.es': 'Velocidad de ejecución',
  'platform.th': 'Horario de trading',
  'platform.in': 'Instrumentos',
  'platform.lt': 'Trading en vivo',
  'platform.ptt': 'Herramientas de trading profesionales',
  'platform.aig': 'Acceda a herramientas de nivel institucional diseñadas para traders profesionales e inversores serios',
  'platform.rtd': 'Datos en tiempo real',
  'platform.lmd': 'Datos de mercado en vivo y actualizaciones instantáneas de precios',
  'platform.pa': 'Alertas de precio',
  'platform.caf': 'Alertas personalizadas para movimientos de precio y eventos de mercado',
  'platform.this': 'Historial de operaciones',
  'platform.cth': 'Historial de trading completo y análisis de rendimiento',
  'platform.ec': 'Calendario económico',
  'platform.suw': 'Manténgase al día con eventos económicos importantes',
  'platform.mw': 'Vigilancia de mercado',
  'platform.rtp': 'Cotizaciones en tiempo real y profundidad de mercado para todos los instrumentos',
  'platform.om': 'Gestión de órdenes',
  'platform.aot': 'Órdenes avanzadas: mercado, límite, stop y stop dinámico (trailing)',
  'platform.ta': 'Análisis técnico',
  'platform.cta': 'Conjunto completo de herramientas de análisis con indicadores personalizados y herramientas de dibujo',
  'platform.ufe': 'Ejecución ultrarrápida',
  'platform.rtc': 'Soporte al cliente ininterrumpido por nuestro equipo de expertos en trading y especialistas técnicos',
  'platform.247a': 'Disponible 24/7',
  'platform.csp': 'Spreads competitivos',
  'platform.iia': 'Spreads líderes del sector y precios transparentes sin comisiones ni cargos ocultos',
  'platform.01pip': 'Desde 0,1 pips',
  'platform.ffd': 'Aplicación de escritorio completa para Windows 10/11',
  'platform.nma': 'Aplicación nativa de macOS con funcionalidad completa',
  'platform.mta': 'Aplicación móvil de trading para dispositivos Android',
  'platform.iai': 'Aplicación de trading para iPhone y iPad',

  // FAQ SECTION
  'faq.tagline': '¿CÓMO PODEMOS AYUDARLE?',
  'faq.title': '¿Cómo podemos ayudarle?',
  'faq.subtitle': 'Explore nuestras secciones de Preguntas Frecuentes para encontrar respuestas rápidas a sus consultas',
  'faq.categories': 'Categorías',

  // Footer help box
  'faq.cantFind': '¿No encuentra lo que busca?',
  'faq.supportText': 'Nuestro equipo de soporte está aquí para ayudarle con cualquier pregunta no cubierta en la sección de FAQ.',
  'faq.contactSupport': 'Contactar al equipo de soporte',

  // Category titles
  'faq.general': 'General',
  'faq.account': 'Cuenta',
  'faq.trading': 'Trading',
  'faq.platform': 'Plataforma',
  'faq.deposits': 'Depósitos y retiros',
  'faq.security': 'Seguridad',

  // General
  'faq.general.q1': '¿Qué es GOLD LABEL GLOBAL LIMITED?',
  'faq.general.a1': 'GOLD LABEL GLOBAL LIMITED es una empresa regulada de trading de metales preciosos con sede en Hong Kong, que ofrece servicios profesionales en oro, plata y otros metales preciosos a través de la plataforma MT5.',
  'faq.general.q2': '¿Qué instrumentos de trading ofrecen?',
  'faq.general.a2': 'Ofrecemos una gama completa de metales preciosos, incluido oro al contado (XAU/USD), plata al contado (XAG/USD), platino, paladio y varios contratos de futuros de metales preciosos.',
  'faq.general.q3': '¿Cuáles son sus horarios de negociación?',
  'faq.general.a3': 'Nuestros mercados de metales preciosos están abiertos 24 horas al día, 5 días a la semana, desde el domingo a las 17:00 (EST) hasta el viernes a las 16:00 (EST), siguiendo los horarios internacionales.',
  'faq.general.q4': '¿Mi inversión está segura con su empresa?',
  'faq.general.a4': 'Sí, estamos completamente regulados y autorizados. Los fondos de los clientes se mantienen segregados en cuentas bancarias seguras. También contamos con una cobertura de seguro integral para mayor protección.',

  // Account
  'faq.account.q1': '¿Cómo abro una cuenta de trading?',
  'faq.account.a1': 'Puede abrir una cuenta en línea completando nuestro formulario, aportando la documentación de identificación requerida y realizando un depósito inicial. El proceso suele tardar de 1 a 2 días hábiles.',
  'faq.account.q2': '¿Cuál es el depósito mínimo requerido?',
  'faq.account.a2': 'El depósito inicial mínimo es de 1.000 USD para una cuenta estándar. También ofrecemos cuentas premium con depósitos mínimos superiores y beneficios adicionales.',
  'faq.account.q3': '¿Puedo tener varias cuentas de trading?',
  'faq.account.a3': 'Sí, puede abrir múltiples cuentas con distintas divisas base o tipos de cuenta para adaptarse a sus estrategias y gestión del riesgo.',
  'faq.account.q4': '¿Cómo verifico mi cuenta?',
  'faq.account.a4': 'La verificación requiere un documento de identidad emitido por el gobierno (pasaporte o licencia de conducir) y un comprobante de domicilio (recibo de servicios o estado de cuenta bancario) de los últimos 3 meses.',

  // Trading
  'faq.trading.q1': '¿Cuál es el tamaño mínimo de operación?',
  'faq.trading.a1': 'El tamaño mínimo es de 0,01 lotes para la mayoría de los instrumentos de metales preciosos, permitiendo una gestión de riesgo flexible para todos los niveles.',
  'faq.trading.q2': '¿Qué apalancamiento ofrecen?',
  'faq.trading.a2': 'Ofrecemos un apalancamiento competitivo de hasta 1:100 para el trading de metales preciosos, lo que le permite maximizar su potencial manteniendo una gestión responsable del riesgo.',
  'faq.trading.q3': '¿Hay comisiones de trading?',
  'faq.trading.a3': 'Operamos con un modelo basado en el spread sin comisiones. Nuestros spreads son competitivos y transparentes, sin costes ocultos.',
  'faq.trading.q4': '¿Puedo usar estrategias de trading automatizadas?',
  'faq.trading.a4': 'Sí, nuestra plataforma MT5 admite por completo los Expert Advisors (EAs) y estrategias automatizadas. Puede desarrollar algoritmos propios o usar robots existentes.',

  // Platform (FAQ)
  'faq.platform.q1': '¿Qué plataformas de trading soportan?',
  'faq.platform.a1': 'Principalmente utilizamos MetaTrader 5 (MT5), la plataforma líder del sector. MT5 está disponible para escritorio (Windows/Mac), móviles (iOS/Android) y navegadores web.',
  'faq.platform.q2': '¿La plataforma MT5 es gratuita?',
  'faq.platform.a2': 'Sí, MT5 es completamente gratuita para descargar y usar. Proporcionamos acceso completo a todas las funciones, gráficos, indicadores y herramientas sin coste adicional.',
  'faq.platform.q3': '¿Puedo operar desde dispositivos móviles?',
  'faq.platform.a3': '¡Por supuesto! Nuestras apps MT5 para iOS y Android ofrecen funcionalidad completa, gráficos en tiempo real, noticias de mercado y gestión de cuenta sobre la marcha.',
  'faq.platform.q4': '¿Ofrecen cuentas demo?',
  'faq.platform.a4': 'Sí, ofrecemos cuentas demo gratuitas con fondos virtuales para practicar y familiarizarse con la plataforma antes de invertir dinero real.',

  // Deposits & Withdrawals
  'faq.deposits.q1': '¿Qué métodos de depósito aceptan?',
  'faq.deposits.a1': 'Aceptamos transferencias bancarias, tarjetas de crédito/débito (Visa, MasterCard) y varios métodos de pago electrónicos. Todos los depósitos se procesan de forma segura y eficiente.',
  'faq.deposits.q2': '¿Cuánto tardan en procesarse los depósitos?',
  'faq.deposits.a2': 'Los depósitos con tarjeta suelen ser instantáneos, mientras que las transferencias bancarias pueden tardar de 1 a 3 días hábiles. Los pagos electrónicos suelen procesarse en pocas horas.',
  'faq.deposits.q3': '¿Existen comisiones por depósito?',
  'faq.deposits.a3': 'No cobramos comisiones por la mayoría de los métodos de depósito. Sin embargo, su banco o proveedor de pagos puede aplicar sus propias tarifas.',
  'faq.deposits.q4': '¿Cómo retiro mis fondos?',
  'faq.deposits.a4': 'Los retiros pueden solicitarse a través de su portal de cliente. Los fondos suelen devolverse por el mismo método utilizado para el depósito, con tiempos de procesamiento variables según el método.',

  // Security
  'faq.security.q1': '¿Cómo protegen mi información personal?',
  'faq.security.a1': 'Utilizamos cifrado de nivel bancario (SSL de 256 bits) para proteger toda la transmisión de datos. Su información se almacena de forma segura y nunca se comparte con terceros sin consentimiento.',
  'faq.security.q2': '¿Hay autenticación de dos factores?',
  'faq.security.a2': 'Sí, recomendamos encarecidamente habilitar la autenticación de dos factores (2FA) para su cuenta. Añade una capa adicional de seguridad contra accesos no autorizados.',
  'faq.security.q3': '¿Qué sucede si olvido mi contraseña?',
  'faq.security.a3': 'Puede restablecer su contraseña mediante el enlace “¿Olvidó su contraseña?” en la página de inicio de sesión. Recibirá por correo un enlace seguro para crear una nueva.',
  'faq.security.q4': '¿Cómo garantizan condiciones de trading justas?',
  'faq.security.a4': 'Ofrecemos precios transparentes con flujos de mercado en tiempo real, sin intervención de mesa de negociación, y un estricto cumplimiento normativo para asegurar un entorno justo y ético para todos los clientes.',

  // Hero
  'hero.browseFAQ': 'Ver FAQ',
  'hero.contactSupport': 'Contactar soporte',

  // Contact CTA
  'contactCTA.phoneTitle': 'Soporte telefónico',
  'contactCTA.phoneDesc': 'Hable directamente con nuestros especialistas',
  'contactCTA.callNow': 'Llamar ahora',
  'contactCTA.emailTitle': 'Soporte por correo electrónico',
  'contactCTA.emailDesc': 'Obtenga respuestas detalladas por escrito',
  'contactCTA.sendMsg': 'Enviar mensaje',
  'contactCTA.chatTitle': 'Chat en vivo',
  'contactCTA.chatDesc': 'Soporte por mensajería instantánea',
  'contactCTA.available': 'Disponible 24/7',
  'contactCTA.startChat': 'Iniciar chat',
  'contactCTA.title': '¿Necesita más ayuda?',
  'contactCTA.subtitle': 'Nuestro equipo de expertos está disponible 24/7 para ayudarle con cualquier pregunta o inquietud.',
  "androidDownload.title": "Descargar MetaTrader 5",
  "androidDownload.description": "Se te redirigirá automáticamente a Google Play. Si Google Play no está disponible en tu dispositivo, puedes descargar el APK directamente.",
  "androidDownload.autoRedirect": "Redirigiendo a Google Play en {{seconds}} segundos",
  "androidDownload.openGooglePlay": "Abrir Google Play",
  "androidDownload.downloadApk": "Descargar APK directamente",
  "androidDownload.hint": "Si Google Play no se abre, toca “Descargar APK directamente”.",
  'windowsDownload.pageTitle': 'Descargar Windows MT5',
  'windowsDownload.pageDesc': 'Elija la versión de instalación adecuada.',
  'windowsDownload.badge': 'Descarga de Windows MT5',
  'windowsDownload.title': 'Elija su paquete de instalación',
  'windowsDownload.description': 'Elija un instalador de Windows MT5. La Gold Label Smooth Stable Version se recomienda para usuarios de China continental y Hong Kong. También puede usar el instalador oficial.',
  'windowsDownload.smoothTitle': '1. Gold Label Smooth Stable Version',
  'windowsDownload.smoothDesc': 'Recomendado para usuarios de Windows en China continental / Hong Kong. Los usuarios de otras regiones también pueden usarlo si el instalador oficial no resulta conveniente.',
  'windowsDownload.smoothButton': 'Descargar Gold Label Smooth Stable Version',
  'windowsDownload.officialTitle': '2. Instalador oficial de MetaQuotes',
  'windowsDownload.officialDesc': 'Enlace de descarga original. Los usuarios de Windows en China continental pueden tener problemas ocasionales de instalación; los usuarios de otras regiones no se ven afectados.',
  'windowsDownload.officialButton': 'Descargar instalador oficial',

  // Economic calendar explorer
  'calendar.hongKongTime': 'Hora de Hong Kong (GMT+8)',
  'calendar.previousDays': '7 días anteriores',
  'calendar.nextDays': '7 días siguientes',
  'calendar.today': 'Hoy',
  'calendar.jumpToDate': 'Ir a la fecha',
  'calendar.completeView': 'Vista completa',
  'calendar.allDays': 'Los 7 días',
  'calendar.events': 'eventos',
  'calendar.impactAll': 'Todos los impactos',
  'calendar.impactHigh': 'Alto',
  'calendar.impactMedium': 'Medio',
  'calendar.impactLow': 'Bajo',
  'calendar.searchPlaceholder': 'Buscar evento, país o divisa',
  'calendar.eventsFound': 'eventos mostrados',
  'calendar.lastUpdated': 'Última actualización',
  'calendar.loadError': 'El calendario económico no está disponible temporalmente.',
  'calendar.noEvents': 'No hay eventos económicos que coincidan con esta vista.',
  'calendar.tryAnotherDate': 'Elige otra fecha o borra los filtros.',
  'calendar.time': 'Hora',
  'calendar.impact': 'Impacto',
  'calendar.released': 'Publicado',
  'calendar.pending': 'Pendiente',
  'calendar.disclaimer': 'Los horarios se muestran en hora de Hong Kong. Las cifras pueden revisarse y se ofrecen solo con fines informativos.',
  'news.tab.newsDesc': 'Últimas noticias del mercado, análisis del oro y contenido educativo',
  'news.tab.calendarDesc': 'Consulta eventos económicos importantes y publicaciones de fechas cercanas',
  'news.autoRefresh': 'Las noticias se actualizan automáticamente',

  'news.tabs.news': 'Noticias',
  'news.tabs.calendar': 'Calendario económico',

};

export default common;
